import React from 'react';
import { useAnswers } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import { CATEGORY_MAPPING, CATEGORIES_FULL_LIST } from '../utils/constants.mjs';


const useProductGroups = () => {

  const { answers } = useAnswers();


  const buildCategoryPriority = () => {
    const reasonForVisit = answers?.preferences_reasonForVisit?.value || []; 
    let priority = { 'member-savings': 1 }; // Always needs to be the first one.
    let counter = 2;

    // Priority based on the order of the reasonForVisit answer
    reasonForVisit.forEach(key => {
      const categories = CATEGORY_MAPPING[key];

      categories.forEach((category) => {
        priority[category] = counter++;
      });
    });

    // Order also for the keys not present on the reasonForVisit answer
    CATEGORIES_FULL_LIST.forEach((key) => {
      if(!priority[key]) {
        priority[key] = counter++;
      }
    });

    return priority;
  }



  const reorderProductGroups = (productGroups) => {
    const order = buildCategoryPriority();

    return productGroups.sort((a, b) => {
      const categoryA = order[a.name];
      const categoryB = order[b.name];
  
      return categoryA - categoryB;
    });

  }


  return {
    reorderProductGroups
  }
}

export default useProductGroups;
